import { createContext } from "react";
import { defaultObject } from "./BookingDefaultData";

export const BookingContext = createContext(defaultObject);